const observers = new WeakMap();

export const observeVisibility = {
  mounted(element, binding) {
    if (!('IntersectionObserver' in window)) {
      binding.value(true, { target: element });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        binding.value(entry.isIntersecting, entry);
        if (entry.isIntersecting) observer.unobserve(element);
      }
    });
    observers.set(element, observer);
    observer.observe(element);
  },
  unmounted(element) {
    observers.get(element)?.disconnect();
    observers.delete(element);
  },
};
